var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "pil venstre",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93337 0.933332C9.44883 1.4488 9.44883 2.28453 8.93337 2.8L3.73337 8L8.93337 13.2C9.44883 13.7155 9.44883 14.5512 8.93337 15.0667C8.4179 15.5821 7.58217 15.5821 7.0667 15.0667L3.31243e-05 8L7.0667 0.933332C7.58217 0.417867 8.4179 0.417868 8.93337 0.933332Z",
    fill: "#0375D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.3699ee21.svg";
export { ForwardRef as ReactComponent };